import React from 'react';
import OrderSelect, { OrderSelectProps } from '../Select';
import { useInnerPackagingTypeGetAll } from '../../../../../../hooks/api/order';

function SelectInnerPackagingType({
  fetch,
  selectProps = {},
  rest = {},
  ...props
}: OrderSelectProps) {
  const dualUseGet = useInnerPackagingTypeGetAll();

  return (
    <OrderSelect
      fetch={dualUseGet}
      selectProps={selectProps}
      rest={rest}
      {...props}
    />
  );
}

export default SelectInnerPackagingType;
